import React from "react";
import plur from "plur";
import { Text } from "@jsq/ds/core";
import { stackedMd } from "../../../../../common/themes/spacing_styles_vanilla.css";
import { GetPaginatedPositionsInAccountWithFiltersQuery } from "../../../../../graphql/supergraph.index";
import { MapPositionConnectionToPositionsPaginatedType } from "../../utils";
import { PositionListBaseComponent } from "../PositionListBaseComponent";

export type PositionListToUpdateComponentWrapperProps = {
  data: GetPaginatedPositionsInAccountWithFiltersQuery;
  fetchMorePositions: () => Promise<void>;
};

export const PositionListToUpdateComponentWrapper: React.FC<
  PositionListToUpdateComponentWrapperProps
> = ({ data, fetchMorePositions }: PositionListToUpdateComponentWrapperProps) => {
  const positionsCount = data?.account?.positions?.count;
  if (data?.account?.positions?.edges && data.account?.positions?.edges.length > 0) {
    return (
      <>
        <Text className={stackedMd}>
          This payment instruction will be applied to {positionsCount === 1 ? "this" : "these"}{" "}
          {positionsCount} {plur("position", positionsCount ?? 1)}
        </Text>
        <PositionListBaseComponent
          positionsPaginated={MapPositionConnectionToPositionsPaginatedType(
            data.account.positions,
          )}
          fetchMorePositions={() => void fetchMorePositions()}
          positionListLoading={false}
          positionListError={undefined}
        />
      </>
    );
  }
  return null;
};
